import React from 'react';

const FilterComponent = ({ filterText, onFilter, onClear }) => (

  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <input
      type="text"
      className="form-control"
      placeholder="Filter by Line"
      value={filterText}
      onChange={onFilter}
    />
    <button className="btn btn-secondary" onClick={onClear} style={{ marginLeft: 8 }}>
      Clear
    </button>
  </div>
);
export default FilterComponent;